import {
  isRecoverableAssetElement,
  isRecoverableAssetLoadError,
  requestAssetRecovery,
} from 'src/utils/asset-recovery';

import * as Sentry from '@sentry/react';

export function registerGlobalErrorListeners() {
  window.addEventListener(
    'error',
    (event) => {
      if (isRecoverableAssetElement(event.target)) {
        requestAssetRecovery('asset-element-error', event);
      }
    },
    true,
  );

  window.onerror = (msg, _url, _line, _col, error) => {
    // error can be null for cross-origin or internal browser errors
    if (error) {
      Sentry.captureException(error);
      console.error(error);
    } else if (msg) {
      // Fallback to message if no error object is available
      Sentry.captureMessage(String(msg));
      console.error(msg);
    }
    if (isRecoverableAssetLoadError(error || msg)) {
      requestAssetRecovery('window-error', error || msg);
    }
  };

  window.onunhandledrejection = (event) => {
    const error = event.reason;
    Sentry.captureException(error);
    console.error(error);

    if (isRecoverableAssetLoadError(error)) {
      requestAssetRecovery('unhandled-rejection', error);
      return;
    }
  };
}
